<template>
	<div>
		<h1>{{ $t('404') }}</h1>
	</div>
</template>

<script>
	export default {
		data() {
			return {};
		},
	};
</script>

<style></style>
